import { CurrencyInrIcon } from './CurrencyInrIcon';

/**
 * author: Austin Andrews
 * id AB8EAA72-9A34-4F87-937A-9A8FDEFA1FEF
 * name currency-inr
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-inr.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const RupeeIcon = CurrencyInrIcon;
export default RupeeIcon